import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/classificationByParamses'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'classificationByParamses'

export const metadata = {
  icon: 'cogs',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const ClassificationByParamsesListPage = createListPage({ metadata, api, actionCreators, Content })
const ClassificationByParamsesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { ClassificationByParamsesListPage, ClassificationByParamsesDetailPage }
